module.exports = __webpack_public_path__ + "img/symbol_2.50697069.png";